import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { History as history, Routes as routes } from '../navigation';
import '../css/SignUp.css';
import { ValidatorUtils } from '../utils';
import { isMobileOnly } from "react-device-detect";

import { SignIn, TitleBar, SingleScreenNavBar, Input, Button, PhoneInput, Header } from  '../components'
import { UserActions, NavigationActions } from '../actions';

class SignUpScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayProfile: true,
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      validation: {},
      loading: false,
    }
  }

  renderProfile = () => {
    if (!this.state.displayProfile) {
      return null;
    }

    let errors = this.state.validation && this.state.validation.errors ? this.state.validation.errors : [];
    let displayLoading = errors.length === 0 && this.state.loading;
    let section_height = errors.length > 2 ? 500 : 400;
        section_height = errors.length === 2 || errors.length === 1 ? 450 : section_height;

    let width  = isMobileOnly ? 340 : 400;

    return <div className="standard-container" style={{ width: width, minWidth: width, minHeight: section_height, maxHeight: section_height }}>
      <Header title='Create Provider Account' icon='fas fa-user-alt' />
      <div className="flex-container-column flex-center-align">
        <Input style={{ marginTop: 15, marginBottom: 10, width: 250 }}
               placeholder='First Name'
               className='instant-input-default'
               value={this.state.firstName}
               invalid={this.state.validation.fields && this.state.validation.fields['firstName']}
               onChange={ (event) => { this.setState({ ...this.state, firstName: event.target.value }) }}
            />
        <Input style={{ marginBottom: 10, width: 250 }}
               placeholder="Last Name"
               className='instant-input-default'
               value={this.state.lastName}
               invalid={this.state.validation.fields && this.state.validation.fields['lastName']}
               onChange={ (event) => { this.setState({ ...this.state, lastName: event.target.value }) }}
            />
        <Input style={{ marginBottom: 10, width: 250 }}
               placeholder="Email"
               className='instant-input-default'
               value={this.state.email}
               invalid={this.state.validation.fields && this.state.validation.fields['email']}
               onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
            />
        <Input style={{ marginBottom: 10, width: 250 }}
               placeholder="Confirm Email"
               className='instant-input-default'
               value={this.state.confirmEmail}
               invalid={this.state.validation.fields && this.state.validation.fields['confirmEmail']}
               onChange={ (event) => { this.setState({ ...this.state, confirmEmail: event.target.value }) }}
            />
        <PhoneInput value={this.state.phone_number}
                    style={{ fontSize: 13 }}
                    placeholder='Cell Phone #'
                    containerStyle={{ width: 250 }}
                    invalid={this.state.validation.fields && this.state.validation.fields['phone_number']}
                    onChange={ (phone_number) => { this.setState({ ...this.state, phone_number: phone_number }) }}/>

      </div>
      <div className="flex-container-column" style={{ alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
        { this.renderErrorMessages(this.state.validation) }
        <span style={{ fontSize: 13, color: 'grey', marginBottom: 10, marginRight: 30, marginLeft: 30, width: 270 }}>
          By creating your TeleTails account you are agreeing to our
          <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Terms & Conditions</a> and
          <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/privacypolicy"> Privacy Policy</a>.
        </span>
        <Button value="Create Account" style={{ paddingRight: 40, paddingLeft: 40, marginTop: 10 }} loading={displayLoading} onClick={ () => { this.createAccount() }} />
      </div>
    </div>
  }

  renderErrorMessages = (validation) => {
    var errors = validation.errors || [];
    if (errors.length > 0) {

      const errorRows = errors.map((error, index) => {
        return <span key={index} style={{ fontSize: 14, color: 'red' }}>{ error }</span>
      });

      return <div className='flex-container-column' style={{ marginBottom: 10 }}>
        { errorRows }
      </div>
    }
  }

  render() {
    return (
      <div className="flex-container flex-container-column">
        <TitleBar
          selectedPractice={''}
          selectedRole={''}
          practices={{}}
          practice={{}}
        />
        <SingleScreenNavBar title="Provider Sign Up" />
        <div className="flex-container flex-container-column flex-center-align sign-up-page">
          <div className="flex-container screen-main-content">
            <div className="screen-container-column flex-container-column" style={{ alignItems: 'center' }}>
              { this.renderProfile() }
            </div>
          </div>

        </div>
      </div>
    );
  }

  createAccount = () => {

    var userInfo = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      phone_number: this.state.phone_number,
      type: 'PROVIDER',
      email: this.state.email,
    }

    var infoToValidate = Object.assign({}, userInfo);
    infoToValidate['confirmEmail']    = this.state.confirmEmail;

    const validation = ValidatorUtils.validate('signUp', infoToValidate);

    if (!validation.valid) {
      this.setState({ ...this.state, validation: validation });
      return;
    } else {
      this.setState({ ...this.state, validation: validation, loading: true });
    }

    this.props.userActions.signUp(userInfo, this.failureCallback, this.successCallback);
  }

  successCallback = () => {
    const screenProps = {
      sign_in_method: 'email',
      email: this.state.email,
      password_login: false,
    }
    history.push({ pathname: routes.USER_SIGN_IN_CODE, state: { props: screenProps } })
    this.setState({ ...this.state, loading: false });
  }

  failureCallback = () => {
    this.setState({ ...this.state, loading: false });
  }

}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpScreen)
